import styled from 'styled-components';

import PlusIcon from '../../svgs/PlusIcon';

import type { MouseEvent } from 'react';

type Props = {
  className?: string;
  size?: number;
  iconSize?: number;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
};

const AddTile = (props: Props) => {
  const { className, size = 72, iconSize = 40, onClick } = props;
  return (
    <Container
      role="button"
      onClick={onClick}
      size={size}
      className={className}
    >
      <PlusIcon
        width={`${iconSize}`}
        height={`${iconSize}`}
        strokeColor="var(--accent)"
      />
    </Container>
  );
};

const Container = styled.div<{ size: number }>`
  background: var(--border);
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: var(--transition-normal);
  &:hover {
    background: var(--text-muted);
    cursor: pointer;
  }
`;

export default AddTile;
